var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 82,
    viewBox: "0 0 83 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4709 0.583984H41.4667C19.0507 0.583984 0.878906 18.7558 0.878906 41.1718C0.878906 63.5878 19.0507 81.7596 41.4667 81.7596H41.4709C63.8869 81.7596 82.0587 63.5878 82.0587 41.1718C82.0587 18.7558 63.8869 0.583984 41.4709 0.583984Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4715 9.60205H41.4682C24.0335 9.60205 9.8999 23.7356 9.8999 41.1703C9.8999 58.605 24.0335 72.7385 41.4682 72.7385H41.4715C58.9062 72.7385 73.0398 58.605 73.0398 41.1703C73.0398 23.7356 58.9062 9.60205 41.4715 9.60205Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6021 48.7848C35.6021 46.9538 36.9211 45.3938 38.7141 45.1048C40.9701 44.7418 43.268 44.7418 45.524 45.1048C47.317 45.3938 48.6371 46.9538 48.6371 48.7848V49.1898C48.6371 50.2608 47.7761 51.1298 46.7141 51.1298H37.5251C36.4631 51.1298 35.6021 50.2608 35.6021 49.1898V48.7848Z",
    fill: "black",
    fillOpacity: 0.15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9209 36.3418C45.9209 38.4588 44.2189 40.1758 42.1189 40.1758C40.0189 40.1758 38.3169 38.4588 38.3169 36.3418C38.3169 34.2238 40.0189 32.5078 42.1189 32.5078C44.2189 32.5078 45.9209 34.2238 45.9209 36.3418Z",
    fill: "black",
    fillOpacity: 0.15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6021 48.7848C35.6021 46.9538 36.9211 45.3938 38.7141 45.1048C40.9701 44.7418 43.268 44.7418 45.524 45.1048C47.317 45.3938 48.6371 46.9538 48.6371 48.7848V49.1898C48.6371 50.2608 47.7761 51.1298 46.7141 51.1298H37.5251C36.4631 51.1298 35.6021 50.2608 35.6021 49.1898V48.7848Z",
    stroke: "black",
    strokeWidth: 2.79326
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9209 36.3418C45.9209 38.4588 44.2189 40.1758 42.1189 40.1758C40.0189 40.1758 38.3169 38.4588 38.3169 36.3418C38.3169 34.2238 40.0189 32.5078 42.1189 32.5078C44.2189 32.5078 45.9209 34.2238 45.9209 36.3418Z",
    stroke: "black",
    strokeWidth: 2.79326
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8789 32.5071C58.8789 28.3931 54.7108 25.0591 49.5688 25.0591M25.3599 49.2671C25.3599 54.4091 28.6949 58.5781 32.8089 58.5781M32.8089 25.0591C28.6949 25.0591 25.3599 28.3931 25.3599 32.5071M49.5688 58.5781C54.7108 58.5781 58.8789 54.4091 58.8789 49.2671",
    stroke: "black",
    strokeWidth: 2.79326,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 9.3559,
    y1: 4.15398,
    x2: 86.4689,
    y2: 21.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.6d3bd9b868b91f8fce948dc485a9d872.svg";
export { ForwardRef as ReactComponent };